import axios from "axios";

import { addProfileVote } from "./ProfileActions";

// --------------------------------------
//              ACTION TYPES
// --------------------------------------
export const POLLS_QUESTIONS_GET_START = "POLLS_QUESTIONS_GET_START";
export const POLLS_QUESTIONS_GET_SUCCESS = "POLLS_QUESTIONS_GET_SUCCESS";
export const POLLS_QUESTIONS_GET_FAIL = "POLLS_QUESTIONS_GET_FAIL";

export const POLLS_VOTE_POST_START = "POLLS_VOTE_POST_START";
export const POLLS_VOTE_POST_SUCCESS = "POLLS_VOTE_POST_SUCCESS";
export const POLLS_VOTE_POST_FAIL = "POLLS_VOTE_POST_FAIL";

export const POLLS_FILTERED_GET_START = "POLLS_FILTERED_GET_START";
export const POLLS_FILTERED_GET_SUCCESS = "POLLS_FILTERED_GET_SUCCESS";
export const POLLS_FILTERED_GET_FAIL = "POLLS_FILTERED_GET_FAIL";

// --------------------------------------
//            ACTION CREATORS
// --------------------------------------

// GET:
export const getPollsQuestionsStart = () => {
  return {
    type: POLLS_QUESTIONS_GET_START,
  };
};

export const getPollsQuestionsSuccess = (questions) => {
  return {
    type: POLLS_QUESTIONS_GET_SUCCESS,
    questions: questions,
    latest: questions[0],
  };
};

export const getPollsQuestionsFail = (error) => {
  return {
    type: POLLS_QUESTIONS_GET_FAIL,
    error: error,
  };
};

export const getPollsQuestions = () => {
  return (dispatch, getState) => {
    dispatch(getPollsQuestionsStart());
    const language = getState().i18nState.lang;
    return axios
      .get(`${process.env.REACT_APP_API_URL}/polls/questions?lang=${language}`)
      .then((res) => {
        dispatch(getPollsQuestionsSuccess(res.data));
        return getState().PollsState.items;
      })
      .catch((err) => {
        dispatch(getPollsQuestionsFail(err));
        throw err;
      });
  };
};

// POST:
export const postPollsVoteStart = () => {
  return {
    type: POLLS_VOTE_POST_START,
  };
};

export const postPollsVoteSuccess = (vote) => {
  return {
    type: POLLS_VOTE_POST_SUCCESS,
    vote: vote,
  };
};

export const postPollsVoteFail = (error) => {
  return {
    type: POLLS_QUESTIONS_GET_FAIL,
  };
};

export const postPollsVote = (payload, latest_vote = false) => {
  return (dispatch, getState) => {
    dispatch(postPollsVoteStart());
    return axios
      .post(`${process.env.REACT_APP_API_URL}/polls/vote`, payload)
      .then((res) => {
        dispatch(postPollsVoteSuccess(payload));
        if (latest_vote) {
          dispatch(addProfileVote(true));
        }
      })
      .catch((err) => {
        dispatch(postPollsVoteFail(err));
        throw err;
      });
  };
};

export const getFilteredPollsStart = () => {
  return {
    type: POLLS_FILTERED_GET_START,
  };
};

export const getFilteredPollsSuccess = (data) => {
  return {
    type: POLLS_FILTERED_GET_SUCCESS,
    filteredPolls: data || [],
  };
};

export const getFilteredPollsFail = (error) => {
  return {
    type: POLLS_FILTERED_GET_FAIL,
    error: error,
  };
};

export const getFilteredPolls = (filters = {}) => {
  return (dispatch, getState) => {
    dispatch(getFilteredPollsStart());

    const language = getState().i18nState.lang;
    const params = new URLSearchParams();

    if (language) params.append("lang", language);
    if (filters.country) params.append("country", filters.country);
    if (filters.gender) params.append("gender", filters.gender);
    if (filters.nationality) params.append("nationality", filters.nationality);
    if (filters.age) params.append("age", filters.age);
    if (filters.profile_id) params.append("profile_id", filters.profile_id);

    return axios
      .get(
        `${
          process.env.REACT_APP_API_V2_URL
        }/polls-questions-filter?${params.toString()}`
      )
      .then((res) => {
        dispatch(getFilteredPollsSuccess(res.data));
        return res.data;
      })
      .catch((err) => {
        dispatch(getFilteredPollsFail(err));
        throw err;
      });
  };
};
